/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    SAVE: 'Save'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Social network',
    USERNAME: 'Username'
  },
  LABEL: {
    CREATE_LINK: 'Add social network',
    EDIT_LINK: 'Edit social network',
    INACTIVATE_LINK: 'Delete social network',
    INACTIVATE_LINK_MODAL_TITLE: 'Delete social network',
    LINK: 'Link',
    SOCIAL_NETWORK: 'Social network',
    USERNAME: 'Username'
  },
  SENTENCE: {
    ERROR: 'Error',
    INACTIVATE_LINK_TEXT: 'Are you sure you want to delete the social network?',
    NO_ROWS_LINKS: 'No social networks'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Social network was successfully inactivated',
    LINKS_DETAILS_SAVED: 'Social network was successfully saved',
    LINKS_DETAILS_UPDATED: 'Social network was successfully updated',
    SUCCESS: 'Sucess'
  },
  TOOLTIP: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Social network',
    USERNAME: 'Username'
  }
};
